import React from 'react';
import './Loading.css';

//Component for displaying a loading animation
const Loading = () => {
    return (
        <div className="loadingio-spinner-ripple-258kijumjq1">
            <div className="ldio-ocxrlsjkcqm">
                <div></div>
                <div></div>
            </div>
        </div>
    );
};

export default Loading;